module.exports = __webpack_public_path__ + "static/media/2.aa7c9e5e.jpg";